import FeladatCsoportTableService from 'app/admin/feladatCsoport/service/FeladatCsoportTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'feladatCsoportTable',
	text: 'Feladat csoportok',
	textKey: 'chapters',
	service: FeladatCsoportTableService,
	icon: 'person',
	editFormState: item => `/feladat-csoport/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'nev',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'nev',
			text: 'Név',
			textKey: 'nev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'rovid',
			text: 'Rövid név',
			textKey: 'rovid',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function FeladatCsoportTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('feladatCsoportTable', reducer('feladatCsoportTable'))(FeladatCsoportTable);
